{
  "loading": "Завантаження…",
  "loadingMore": "Завантаження інших об’єктів..."
}
